import api from "../utils/axiosInstance";

export const getCollections = async () => {

  try {

    const response =
      await api.get("/api/collections");

    return response.data;

  } catch (error) {

    console.error(error);

    return [];

  }

};

export const getCollectionBySlug =
  async (slug) => {

  try {

    const response =
      await api.get(
        `/api/collections/slug/${slug}`
      );

    return response.data;

  } catch (error) {

    console.error(error);

    return null;

  }

};